<template>
  <Dialog
    v-model:visible="visibleDialog"
    :style="{ width: '480px' }"
    header="Fomulário de Responsável"
    :modal="true"
    @hide="hideDialog"
    class="p-fluid"
  >
    <div class="field">
      <label for="credential">Matrícula</label>
      <div class="p-inputgroup">
        <InputText
          id="credential"
          v-model="v$.obj.credential.$model"
          placeholder="Digite a matrícula do responsável"
          :class="{ 'p-invalid': submitted && v$.obj.credential.$invalid }"
          :disabled="obj.id"
        />
        <Button v-if="!obj.id" icon="pi pi-search" @click="findPerson" />
      </div>
      <small class="p-error" v-if="submitted && v$.obj.credential.$invalid">
        Matrícula do responsável é obrigatório.
      </small>
      <Chip v-if="obj.person" :label="obj.name" class="mt-2 mb-2" />
    </div>

    <div class="field" v-if="obj.person">
      <label for="email">E-mail</label>
      <InputText
        id="email"
        v-model="v$.obj.email.$model"
        maxlength="100"
        type="email"
        placeholder="Digite o e-mail do responsável"
        :class="{ 'p-invalid': submitted && v$.obj.email.$invalid }"
      />
      <small class="p-error" v-if="submitted && v$.obj.email.$invalid">
        E-mail do responsável deve ser válido.
      </small>
    </div>
    <template #footer>
      <Button
        v-if="obj.person"
        label="Salvar"
        class="p-button"
        icon="pi pi-check"
        @click="send(!v$.obj.$invalid)"
      />
      <Button
        label="Cancelar"
        icon="pi pi-times"
        class="p-button p-button-text"
        @click="hideDialog"
      />
    </template>
  </Dialog>
</template>

<script>
//Models
import Responsible from "../../../../src/models/internal/responsible";

//Services
import ResponsibleService from "../../../../src/service//internal/responsible/responsible_service";
import PersonService from "../../../service/intranet/person/person_service";

//VALIDATIONS
import { useVuelidate } from "@vuelidate/core";

export default {
  props: ["objSelected"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      obj: new Responsible({}),
      submitted: false,
      service: new ResponsibleService(),
      personService: new PersonService(),
      originalResponsibleName: null,
    };
  },
  validations() {
    return {
      obj: new Responsible({}).validations(),
    };
  },
  computed: {
    visibleDialog: {
      get() {
        let value = this.$store.state.views.responsible.dialogForm;
        if (value === true) this.getData();
        return value;
      },
      set(value) {
        this.$store.state.views.responsible.dialogForm = value;
      },
    },
  },
  methods: {
    async send(isFormValid) {
      this.submitted = true;

      // Aguarda a resolução de findPerson
      let foundPerson = await this.findPerson();

      if (isFormValid) {
        if (foundPerson) {
          // Somente segue se a pessoa for encontrada
          if (this.obj.id) {
            // Verificar se a matrícula foi alterada manualmente
            if (this.originalResponsibleCredential != this.obj.credential) {
              this.$msgWarn(
                "Uma vez a matrícula inserida, não pode ser trocada."
              );
              return;
            }
            this.update();
          } else {
            this.create();
          }
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Atenção.",
            detail: "Digite uma matrícula de um servidor existente",
            life: 6000,
          });
        }
      } else {
        return;
      }
    },
    create() {
      this.submitted = true;
      this.service
        .create(this.obj.toJson())
        .then((data) => {
          if (data.status === 201) {
            this.$msgSuccess(data);
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    update() {
      this.submitted = true;
      this.service
        .update(this.obj.toJson())
        .then((data) => {
          if (data.status === 200) {
            this.$msgSuccess(data);
            this.hideDialog();
          }
        })
        .catch((error) => {
          this.$msgErro(error);
        });
    },
    hideDialog() {
      this.obj = new Responsible({});
      this.submitted = false;
      this.$emit("findAll");
      this.visibleDialog = false;
    },
    findPerson() {
      return this.personService
        .findByCpfOrCredential(this.obj.credential)
        .then((data) => {
          this.obj.person = data.id;
          this.obj.name = data.name;
          return true; // Retorna true caso encontre a pessoa
        })
        .catch(() => {
          if (!this.obj.id) {
            this.obj.person = null;
            this.obj.email = null;
          }
          this.$msgWarn("Matrícula não encontrada");
          this.obj.name = null;
          return false; // Retorna false caso não encontre a pessoa
        });
    },
    getData() {
      this.obj = new Responsible(this.objSelected);
      if (this.obj.id) {
        this.originalResponsibleCredential = this.objSelected.credential;
      }
    },
  },
};
</script>
